import React from 'react';
import {connect} from 'react-redux';
import {
    closeFormSectionPopup, 
    updateFormSectionContents, 
} from '../../actions';
import {
    updateTitleFieldInTheSectionEditPopup,
    updateBodyFieldInTheSectionEditPopup,
    updateFormTypeFieldInTheSectionEditPopup
} from '../../sections/actions';
import {fetchFormTypes} from '../../thunks';
import FormSectionEditPopup from './form_section_edit';

class FormPopup extends React.Component {

    componentDidMount() {
        if (this.props.sectionTypeForm.length > 0) {
            this.props.fetchFormTypes(this.props.pageId, this.props.siteId);
        }
    }

    render () {
        return (
            <FormSectionEditPopup
                open={this.props.formSectionEditOpen}
                title={this.props.formSectionTitle}
                selectedForm={this.props.selectedForm}
                body={this.props.formSectionBody}
                formTypes={this.props.formTypes}
                pageId={this.props.pageId}
                sectionId={this.props.formSectionId}
                onUpdateTitleField={
                    title => this.props.updateFormSectionTitleField(title)
                }
                onUpdateBodyField={
                    body => this.props.updateFormSectionBodyField(body)
                }
                onUpdateFormType={
                    selectedForm => this.props.updateFormSectionTypeField(selectedForm)
                }
                onHandleSubmit={() =>
                    this.props.updateFormSectionContents(
                        this.props.pageId,
                        this.props.formSectionId,
                        this.props.sectionData,
                        this.props.selectedSettings
                    )
                }
                onHandleClose={
                    () => this.props.closeFormSectionPopup()
                }
            />
        )
    }
}

const mapStateToProps = (state, props) => ({
    sectionData: state.pageBuilderSectionPopup.data,
    selectedSettings: state.pageBuilderSectionPopup.settings,
    formSectionEditOpen: state.pageBuilder.formSectionPopup.open,
    formSectionTitle: state.pageBuilderSectionPopup.data.title,
    formSectionBody: state.pageBuilderSectionPopup.data.body,
    formSectionId: state.pageBuilderSectionPopup.sectionId,
    selectedForm: state.pageBuilderSectionPopup.data.form_id,
    formTypes: state.pageBuilder.formTypes,
    siteId: state.pageBuilder.pages[props.pageId].meta.site_id
});

export default connect(
    mapStateToProps, {
        closeFormSectionPopup: closeFormSectionPopup,
        updateFormSectionTitleField: updateTitleFieldInTheSectionEditPopup,
        updateFormSectionBodyField: updateBodyFieldInTheSectionEditPopup,
        updateFormSectionContents: updateFormSectionContents,
        updateFormSectionTypeField: updateFormTypeFieldInTheSectionEditPopup,
        fetchFormTypes: fetchFormTypes,
    }
)(FormPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/form_popup.js